"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    base: '0px',
    '2xs': '320px',
    xs: '414px',
    sm: '576px',
    md: '768px',
    lg: '1000px',
    xl: '1200px',
    '2xl': '1536px',
};
